import { NgModule,LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { registerLocaleData } from '@angular/common';
import localeId from '@angular/common/locales/id';
registerLocaleData(localeId);

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { EmailComposer } from '@ionic-native/email-composer/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { Camera } from '@ionic-native/camera/ngx';

import { File } from '@ionic-native/file/ngx';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { StreamingMedia } from '@ionic-native/streaming-media/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';

import { environment } from '../environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CheckoutInfoPageModule } from './transaction/buyticket/checkout-info/checkout-info.module';
import { TicketcodePageModule } from './profiles/ticketcode/ticketcode.module';
import { TicketsuccessPageModule } from './profiles/ticketsuccess/ticketsuccess.module';
import { ModalverifyphonePageModule } from './profiles/modalverifyphone/modalverifyphone.module';
import { ModalverifyemailPageModule } from './profiles/modalverifyemail/modalverifyemail.module';
import { ModalquestionPageModule } from './event/session/sessiondetail/modalquestion/modalquestion.module';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from "@angular/fire/firestore";
//import * as firebase from 'firebase'
import * as $ from 'jquery';
import firebase from 'firebase/app';
import 'firebase/database'; // If using Firebase database
import 'firebase/storage';
import 'firebase/auth';
import { Zoom } from '@ionic-native/zoom/ngx';
import { TimesagoPipe } from './pipes/timesago.pipe';
import { YoutubePipe } from './youtube.pipe';
import { SharedModule } from './shared/shared/shared.module';

import { IonicStorageModule } from '@ionic/storage';
import { Network } from '@ionic-native/network/ngx';

firebase.initializeApp(environment.firebase);

@NgModule({
  declarations: [AppComponent, YoutubePipe],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    //ServiceWorkerModule,
    CheckoutInfoPageModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule
  ],
  providers: [
    BarcodeScanner,
    Geolocation,
		LocationAccuracy,
    AndroidPermissions,
    AppVersion,
    EmailComposer,
    Camera,
    File,
    FileTransfer,
    FileOpener,
    Zoom,
    StreamingMedia,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LOCALE_ID, useValue: 'id-ID' },
    Network
  ],
  bootstrap: [AppComponent]
})
export class AppModule {


}
